import { render, staticRenderFns } from "./PaymentProviderNotice.vue?vue&type=template&id=b28858fe&scoped=true&"
import script from "./PaymentProviderNotice.vue?vue&type=script&lang=js&"
export * from "./PaymentProviderNotice.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProviderNotice.vue?vue&type=style&index=0&id=b28858fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28858fe",
  null
  
)

export default component.exports